import { urlLanding } from 'lib/urlLanding';

export const inforSomai = {
	url: urlLanding,
	title: 'Informação científica para ajudar os povos indígenas na adaptação aos impactos da mudança do clima.',
	hashtag: '#somai'
};
